import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import PrimaryButton from '../PrimaryButton';
import { useAuth } from '../../../hooks/auth';
import { useToast } from '../../../hooks/toast';

import { BlockedNotice } from './styles';

interface ICreateTournamentButtonProps {
  /** Repassado ao botão — as páginas de torneio estilizam pelo id. */
  id?: string;
  label?: string;
}

export const DEFAULT_SCHOOL_TOURNAMENT_MESSAGE =
  'Não é possível criar torneio na escola Fuzzy Makers. Escolha no seu perfil o colégio ao qual você pertence.';

/**
 * Botão de criar torneio. Enquanto o usuário estiver na escola padrão da
 * plataforma, o clique mostra um toast com o motivo em vez de navegar — um
 * botão `disabled` não dispara clique e o usuário ficava sem resposta.
 *
 * Renderiza SÓ o botão, sem wrapper: os cabeçalhos das duas páginas de torneio
 * dimensionam o botão por `> .primary-button`, e qualquer elemento no meio
 * quebraria esse seletor. A explicação vive no `TournamentSchoolNotice`, que
 * cada página posiciona onde couber.
 */
export const CreateTournamentButton: React.FC<ICreateTournamentButtonProps> = ({
  id,
  label = 'Criar Torneio Local',
}) => {
  const navigate = useNavigate();
  const { onDefaultSchool } = useAuth();
  const { addToast } = useToast();

  const handleClick = useCallback(() => {
    if (onDefaultSchool) {
      addToast({
        type: 'error',
        expression: 'Ops!',
        description: DEFAULT_SCHOOL_TOURNAMENT_MESSAGE,
      });
      return;
    }

    navigate('/tournament/create');
  }, [addToast, navigate, onDefaultSchool]);

  return (
    <PrimaryButton
      id={id}
      type="button"
      onClick={handleClick}
      aria-disabled={onDefaultSchool}
      title={onDefaultSchool ? DEFAULT_SCHOOL_TOURNAMENT_MESSAGE : undefined}
    >
      {label}
    </PrimaryButton>
  );
};

/**
 * Motivo do botão desabilitado. Fica junto do botão de propósito: se as duas
 * páginas escrevessem a própria mensagem, o mesmo bloqueio seria explicado de
 * um jeito na lista e de outro no briefing.
 */
export const TournamentSchoolNotice: React.FC = () => {
  const navigate = useNavigate();
  const { onDefaultSchool } = useAuth();

  if (!onDefaultSchool) {
    return null;
  }

  return (
    <BlockedNotice>
      Para criar um torneio, troque a escola padrão (Fuzzy Makers) pelo colégio
      ao qual você pertence — se ele ainda não existir na plataforma, dá para
      cadastrá-lo na hora.{' '}
      <button type="button" onClick={() => navigate('/profile')}>
        Alterar escola no perfil
      </button>
    </BlockedNotice>
  );
};

export default CreateTournamentButton;
